import { api } from "@api/api";
import { Discount } from "@modules/discounts/types";
import { ApiResponse } from "@shared/types";
import { ListDiscountsQueryFilters } from "./types";

export async function listDiscountsService(
  filters?: ListDiscountsQueryFilters
): Promise<Discount[]> {
  const { data } = await api.get<ApiResponse<Discount>>("/v1/discount_admin/", {
    params: {
      page: filters?.page,
      page_size: filters?.perPage,
      search: filters?.search,
      ids: Array.isArray(filters?.ids) ? filters.ids.join(",") : undefined,
    },
  });

  return data.results;
}
